import NavBar from '@components/common/navbar'
import FirstFold from '@components/national-coding-olympiad-2021/thank-you-page/first-fold'
import ResourceFold from '@components/national-coding-olympiad-2021/thank-you-page/resource-fold'
import Banner from '@components/national-coding-olympiad-2021/thank-you-page/banner'
import Footer from '@components/common/footer'
import {
  APP_DEVELOPMENT_MASTERCLASS,
  GAME_DEVELOPMENT_MASTERCLASS,
  WEB_DEVELOPMENT_MASTERCLASS,
  SCRATCH_PROGRAMMING_MASTERCLASS,
  ANIMATION_MASTERCLASS,
} from '@lib/data/nco-thank-you-page'
import { NextSeo } from 'next-seo'
import { masterClasses } from '@lib/seo'

const EVEN_FOLD_BG_COLOUR =
  'linear-gradient(101.28deg, #FFF5EC -19.37%, #FFEAD7 106.43%)'
const MasterClassThankYouPage = () => (
  <>
    <NextSeo {...masterClasses} />
    <NavBar isSticky />
    <FirstFold
      title="Masterclasses for winners"
      subHeading="Watch our curated masterclasses to learn more about competitive coding and to sharpen your coding skills."
    />
    <div style={{ background: '#FBFBFB' }}>
      <ResourceFold
        heading="App development masterclasses"
        resourceData={APP_DEVELOPMENT_MASTERCLASS}
        imagePath="/images/national-coding-olympiad/thank-you-page/app-development-masterclasses/"
        ctaText="Watch masterclass"
      />
      <div
        style={{
          background: EVEN_FOLD_BG_COLOUR,
        }}
      >
        <ResourceFold
          heading="Game development masterclasses"
          resourceData={GAME_DEVELOPMENT_MASTERCLASS}
          imagePath="/images/national-coding-olympiad/thank-you-page/game-development-masterclasses/"
          ctaText="Watch masterclass"
        />
      </div>
      <ResourceFold
        heading="Web development masterclasses"
        resourceData={WEB_DEVELOPMENT_MASTERCLASS}
        imagePath="/images/national-coding-olympiad/thank-you-page/web-development-masterclasses/"
        ctaText="Watch masterclass"
      />
      <div
        style={{
          background: EVEN_FOLD_BG_COLOUR,
        }}
      >
        <ResourceFold
          heading="Scratch programming masterclasses"
          resourceData={SCRATCH_PROGRAMMING_MASTERCLASS}
          imagePath="/images/national-coding-olympiad/thank-you-page/scratch-programming-masterclasses/"
          ctaText="Watch masterclass"
        />
      </div>
      <ResourceFold
        heading="Animation masterclasses"
        resourceData={ANIMATION_MASTERCLASS}
        imagePath="/images/national-coding-olympiad/thank-you-page/animation-masterclasses/"
        ctaText="Watch masterclass"
      />
    </div>
    <Banner />
    <Footer />
  </>
)

export default MasterClassThankYouPage
